/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from "@tanstack/react-router";

// Import Routes

import { Route as rootRoute } from "./routes/__root";
import { Route as TenantIdMessengerIdHostConfigLauncherLayoutImport } from "./routes/$tenantId/$messengerId/$hostConfig/_launcherLayout";
import { Route as TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutImport } from "./routes/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout";
import { Route as TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutImport } from "./routes/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout";
import { Route as TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesNewIndexImport } from "./routes/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/new/index";

// Create Virtual Routes

const TenantIdMessengerIdHostConfigImport = createFileRoute(
  "/$tenantId/$messengerId/$hostConfig",
)();
const TenantIdMessengerIdHostConfigLauncherLayoutLocaleImport = createFileRoute(
  "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale",
)();
const TenantIdMessengerIdHostConfigLauncherLayoutIndexLazyImport = createFileRoute(
  "/$tenantId/$messengerId/$hostConfig/_launcherLayout/",
)();
const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutLoginIndexLazyImport =
  createFileRoute(
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/login/",
  )();
const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutLauncherIndexLazyImport =
  createFileRoute(
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/launcher/",
  )();
const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutNewsIndexLazyImport =
  createFileRoute(
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/news/",
  )();
const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesIndexLazyImport =
  createFileRoute(
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/",
  )();
const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutLauncherAuthIndexLazyImport =
  createFileRoute(
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/launcherAuth/",
  )();
const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHomeIndexLazyImport =
  createFileRoute(
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/home/",
  )();
const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHelpIndexLazyImport =
  createFileRoute(
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/help/",
  )();
const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesIdIndexLazyImport =
  createFileRoute(
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/$id/",
  )();
const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHelpTypeIdIndexLazyImport =
  createFileRoute(
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/help/$type/$id/",
  )();

// Create/Update Routes

const TenantIdMessengerIdHostConfigRoute = TenantIdMessengerIdHostConfigImport.update({
  id: "/$tenantId/$messengerId/$hostConfig",
  path: "/$tenantId/$messengerId/$hostConfig",
  getParentRoute: () => rootRoute,
} as any);

const TenantIdMessengerIdHostConfigLauncherLayoutRoute =
  TenantIdMessengerIdHostConfigLauncherLayoutImport.update({
    id: "/_launcherLayout",
    getParentRoute: () => TenantIdMessengerIdHostConfigRoute,
  } as any);

const TenantIdMessengerIdHostConfigLauncherLayoutLocaleRoute =
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleImport.update({
    id: "/$locale",
    path: "/$locale",
    getParentRoute: () => TenantIdMessengerIdHostConfigLauncherLayoutRoute,
  } as any);

const TenantIdMessengerIdHostConfigLauncherLayoutIndexLazyRoute =
  TenantIdMessengerIdHostConfigLauncherLayoutIndexLazyImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => TenantIdMessengerIdHostConfigLauncherLayoutRoute,
  } as any).lazy(() =>
    import("./routes/$tenantId/$messengerId/$hostConfig/_launcherLayout/index.lazy").then(
      (d) => d.Route,
    ),
  );

const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutRoute =
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutImport.update({
    id: "/_localeLayout",
    getParentRoute: () => TenantIdMessengerIdHostConfigLauncherLayoutLocaleRoute,
  } as any);

const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutRoute =
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutImport.update({
    id: "/_tabsLayout",
    getParentRoute: () => TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutRoute,
  } as any);

const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutLoginIndexLazyRoute =
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutLoginIndexLazyImport.update({
    id: "/login/",
    path: "/login/",
    getParentRoute: () => TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutRoute,
  } as any).lazy(() =>
    import(
      "./routes/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/login/index.lazy"
    ).then((d) => d.Route),
  );

const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutLauncherIndexLazyRoute =
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutLauncherIndexLazyImport.update({
    id: "/launcher/",
    path: "/launcher/",
    getParentRoute: () => TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutRoute,
  } as any).lazy(() =>
    import(
      "./routes/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/launcher/index.lazy"
    ).then((d) => d.Route),
  );

const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutNewsIndexLazyRoute =
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutNewsIndexLazyImport.update(
    {
      id: "/news/",
      path: "/news/",
      getParentRoute: () =>
        TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      "./routes/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/news/index.lazy"
    ).then((d) => d.Route),
  );

const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesIndexLazyRoute =
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesIndexLazyImport.update(
    {
      id: "/messages/",
      path: "/messages/",
      getParentRoute: () =>
        TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      "./routes/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/index.lazy"
    ).then((d) => d.Route),
  );

const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutLauncherAuthIndexLazyRoute =
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutLauncherAuthIndexLazyImport.update(
    {
      id: "/launcherAuth/",
      path: "/launcherAuth/",
      getParentRoute: () =>
        TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      "./routes/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/launcherAuth/index.lazy"
    ).then((d) => d.Route),
  );

const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHomeIndexLazyRoute =
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHomeIndexLazyImport.update(
    {
      id: "/home/",
      path: "/home/",
      getParentRoute: () =>
        TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      "./routes/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/home/index.lazy"
    ).then((d) => d.Route),
  );

const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHelpIndexLazyRoute =
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHelpIndexLazyImport.update(
    {
      id: "/help/",
      path: "/help/",
      getParentRoute: () =>
        TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      "./routes/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/help/index.lazy"
    ).then((d) => d.Route),
  );

const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesIdIndexLazyRoute =
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesIdIndexLazyImport.update(
    {
      id: "/messages/$id/",
      path: "/messages/$id/",
      getParentRoute: () =>
        TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      "./routes/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/$id/index.lazy"
    ).then((d) => d.Route),
  );

const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesNewIndexRoute =
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesNewIndexImport.update(
    {
      id: "/messages/new/",
      path: "/messages/new/",
      getParentRoute: () =>
        TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      "./routes/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/new/index.lazy"
    ).then((d) => d.Route),
  );

const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHelpTypeIdIndexLazyRoute =
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHelpTypeIdIndexLazyImport.update(
    {
      id: "/help/$type/$id/",
      path: "/help/$type/$id/",
      getParentRoute: () =>
        TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      "./routes/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/help/$type/$id/index.lazy"
    ).then((d) => d.Route),
  );

// Populate the FileRoutesByPath interface

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/$tenantId/$messengerId/$hostConfig": {
      id: "/$tenantId/$messengerId/$hostConfig";
      path: "/$tenantId/$messengerId/$hostConfig";
      fullPath: "/$tenantId/$messengerId/$hostConfig";
      preLoaderRoute: typeof TenantIdMessengerIdHostConfigImport;
      parentRoute: typeof rootRoute;
    };
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout": {
      id: "/$tenantId/$messengerId/$hostConfig/_launcherLayout";
      path: "/$tenantId/$messengerId/$hostConfig";
      fullPath: "/$tenantId/$messengerId/$hostConfig";
      preLoaderRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutImport;
      parentRoute: typeof TenantIdMessengerIdHostConfigRoute;
    };
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/": {
      id: "/$tenantId/$messengerId/$hostConfig/_launcherLayout/";
      path: "/";
      fullPath: "/$tenantId/$messengerId/$hostConfig/";
      preLoaderRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutIndexLazyImport;
      parentRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutImport;
    };
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale": {
      id: "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale";
      path: "/$locale";
      fullPath: "/$tenantId/$messengerId/$hostConfig/$locale";
      preLoaderRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleImport;
      parentRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutImport;
    };
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout": {
      id: "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout";
      path: "/$locale";
      fullPath: "/$tenantId/$messengerId/$hostConfig/$locale";
      preLoaderRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutImport;
      parentRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleRoute;
    };
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout": {
      id: "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout";
      path: "";
      fullPath: "/$tenantId/$messengerId/$hostConfig/$locale";
      preLoaderRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutImport;
      parentRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutImport;
    };
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/launcher/": {
      id: "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/launcher/";
      path: "/launcher";
      fullPath: "/$tenantId/$messengerId/$hostConfig/$locale/launcher";
      preLoaderRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutLauncherIndexLazyImport;
      parentRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutImport;
    };
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/login/": {
      id: "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/login/";
      path: "/login";
      fullPath: "/$tenantId/$messengerId/$hostConfig/$locale/login";
      preLoaderRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutLoginIndexLazyImport;
      parentRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutImport;
    };
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/help/": {
      id: "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/help/";
      path: "/help";
      fullPath: "/$tenantId/$messengerId/$hostConfig/$locale/help";
      preLoaderRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHelpIndexLazyImport;
      parentRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutImport;
    };
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/home/": {
      id: "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/home/";
      path: "/home";
      fullPath: "/$tenantId/$messengerId/$hostConfig/$locale/home";
      preLoaderRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHomeIndexLazyImport;
      parentRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutImport;
    };
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/launcherAuth/": {
      id: "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/launcherAuth/";
      path: "/launcherAuth";
      fullPath: "/$tenantId/$messengerId/$hostConfig/$locale/launcherAuth";
      preLoaderRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutLauncherAuthIndexLazyImport;
      parentRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutImport;
    };
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/": {
      id: "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/";
      path: "/messages";
      fullPath: "/$tenantId/$messengerId/$hostConfig/$locale/messages";
      preLoaderRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesIndexLazyImport;
      parentRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutImport;
    };
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/news/": {
      id: "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/news/";
      path: "/news";
      fullPath: "/$tenantId/$messengerId/$hostConfig/$locale/news";
      preLoaderRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutNewsIndexLazyImport;
      parentRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutImport;
    };
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/new/": {
      id: "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/new/";
      path: "/messages/new";
      fullPath: "/$tenantId/$messengerId/$hostConfig/$locale/messages/new";
      preLoaderRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesNewIndexImport;
      parentRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutImport;
    };
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/$id/": {
      id: "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/$id/";
      path: "/messages/$id";
      fullPath: "/$tenantId/$messengerId/$hostConfig/$locale/messages/$id";
      preLoaderRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesIdIndexLazyImport;
      parentRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutImport;
    };
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/help/$type/$id/": {
      id: "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/help/$type/$id/";
      path: "/help/$type/$id";
      fullPath: "/$tenantId/$messengerId/$hostConfig/$locale/help/$type/$id";
      preLoaderRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHelpTypeIdIndexLazyImport;
      parentRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutImport;
    };
  }
}

// Create and export the route tree

interface TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutRouteChildren {
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHelpIndexLazyRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHelpIndexLazyRoute;
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHomeIndexLazyRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHomeIndexLazyRoute;
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutLauncherAuthIndexLazyRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutLauncherAuthIndexLazyRoute;
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesIndexLazyRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesIndexLazyRoute;
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutNewsIndexLazyRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutNewsIndexLazyRoute;
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesNewIndexRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesNewIndexRoute;
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesIdIndexLazyRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesIdIndexLazyRoute;
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHelpTypeIdIndexLazyRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHelpTypeIdIndexLazyRoute;
}

const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutRouteChildren: TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutRouteChildren =
  {
    TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHelpIndexLazyRoute:
      TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHelpIndexLazyRoute,
    TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHomeIndexLazyRoute:
      TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHomeIndexLazyRoute,
    TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutLauncherAuthIndexLazyRoute:
      TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutLauncherAuthIndexLazyRoute,
    TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesIndexLazyRoute:
      TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesIndexLazyRoute,
    TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutNewsIndexLazyRoute:
      TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutNewsIndexLazyRoute,
    TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesNewIndexRoute:
      TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesNewIndexRoute,
    TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesIdIndexLazyRoute:
      TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesIdIndexLazyRoute,
    TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHelpTypeIdIndexLazyRoute:
      TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHelpTypeIdIndexLazyRoute,
  };

const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutRouteWithChildren =
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutRoute._addFileChildren(
    TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutRouteChildren,
  );

interface TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutRouteChildren {
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutRouteWithChildren;
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutLauncherIndexLazyRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutLauncherIndexLazyRoute;
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutLoginIndexLazyRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutLoginIndexLazyRoute;
}

const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutRouteChildren: TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutRouteChildren =
  {
    TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutRoute:
      TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutRouteWithChildren,
    TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutLauncherIndexLazyRoute:
      TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutLauncherIndexLazyRoute,
    TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutLoginIndexLazyRoute:
      TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutLoginIndexLazyRoute,
  };

const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutRouteWithChildren =
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutRoute._addFileChildren(
    TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutRouteChildren,
  );

interface TenantIdMessengerIdHostConfigLauncherLayoutLocaleRouteChildren {
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutRouteWithChildren;
}

const TenantIdMessengerIdHostConfigLauncherLayoutLocaleRouteChildren: TenantIdMessengerIdHostConfigLauncherLayoutLocaleRouteChildren =
  {
    TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutRoute:
      TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutRouteWithChildren,
  };

const TenantIdMessengerIdHostConfigLauncherLayoutLocaleRouteWithChildren =
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleRoute._addFileChildren(
    TenantIdMessengerIdHostConfigLauncherLayoutLocaleRouteChildren,
  );

interface TenantIdMessengerIdHostConfigLauncherLayoutRouteChildren {
  TenantIdMessengerIdHostConfigLauncherLayoutIndexLazyRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutIndexLazyRoute;
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleRouteWithChildren;
}

const TenantIdMessengerIdHostConfigLauncherLayoutRouteChildren: TenantIdMessengerIdHostConfigLauncherLayoutRouteChildren =
  {
    TenantIdMessengerIdHostConfigLauncherLayoutIndexLazyRoute:
      TenantIdMessengerIdHostConfigLauncherLayoutIndexLazyRoute,
    TenantIdMessengerIdHostConfigLauncherLayoutLocaleRoute:
      TenantIdMessengerIdHostConfigLauncherLayoutLocaleRouteWithChildren,
  };

const TenantIdMessengerIdHostConfigLauncherLayoutRouteWithChildren =
  TenantIdMessengerIdHostConfigLauncherLayoutRoute._addFileChildren(
    TenantIdMessengerIdHostConfigLauncherLayoutRouteChildren,
  );

interface TenantIdMessengerIdHostConfigRouteChildren {
  TenantIdMessengerIdHostConfigLauncherLayoutRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutRouteWithChildren;
}

const TenantIdMessengerIdHostConfigRouteChildren: TenantIdMessengerIdHostConfigRouteChildren = {
  TenantIdMessengerIdHostConfigLauncherLayoutRoute:
    TenantIdMessengerIdHostConfigLauncherLayoutRouteWithChildren,
};

const TenantIdMessengerIdHostConfigRouteWithChildren =
  TenantIdMessengerIdHostConfigRoute._addFileChildren(TenantIdMessengerIdHostConfigRouteChildren);

export interface FileRoutesByFullPath {
  "/$tenantId/$messengerId/$hostConfig": typeof TenantIdMessengerIdHostConfigLauncherLayoutRouteWithChildren;
  "/$tenantId/$messengerId/$hostConfig/": typeof TenantIdMessengerIdHostConfigLauncherLayoutIndexLazyRoute;
  "/$tenantId/$messengerId/$hostConfig/$locale": typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutRouteWithChildren;
  "/$tenantId/$messengerId/$hostConfig/$locale/launcher": typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutLauncherIndexLazyRoute;
  "/$tenantId/$messengerId/$hostConfig/$locale/login": typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutLoginIndexLazyRoute;
  "/$tenantId/$messengerId/$hostConfig/$locale/help": typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHelpIndexLazyRoute;
  "/$tenantId/$messengerId/$hostConfig/$locale/home": typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHomeIndexLazyRoute;
  "/$tenantId/$messengerId/$hostConfig/$locale/launcherAuth": typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutLauncherAuthIndexLazyRoute;
  "/$tenantId/$messengerId/$hostConfig/$locale/messages": typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesIndexLazyRoute;
  "/$tenantId/$messengerId/$hostConfig/$locale/news": typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutNewsIndexLazyRoute;
  "/$tenantId/$messengerId/$hostConfig/$locale/messages/new": typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesNewIndexRoute;
  "/$tenantId/$messengerId/$hostConfig/$locale/messages/$id": typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesIdIndexLazyRoute;
  "/$tenantId/$messengerId/$hostConfig/$locale/help/$type/$id": typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHelpTypeIdIndexLazyRoute;
}

export interface FileRoutesByTo {
  "/$tenantId/$messengerId/$hostConfig": typeof TenantIdMessengerIdHostConfigLauncherLayoutIndexLazyRoute;
  "/$tenantId/$messengerId/$hostConfig/$locale": typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutRouteWithChildren;
  "/$tenantId/$messengerId/$hostConfig/$locale/launcher": typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutLauncherIndexLazyRoute;
  "/$tenantId/$messengerId/$hostConfig/$locale/login": typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutLoginIndexLazyRoute;
  "/$tenantId/$messengerId/$hostConfig/$locale/help": typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHelpIndexLazyRoute;
  "/$tenantId/$messengerId/$hostConfig/$locale/home": typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHomeIndexLazyRoute;
  "/$tenantId/$messengerId/$hostConfig/$locale/launcherAuth": typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutLauncherAuthIndexLazyRoute;
  "/$tenantId/$messengerId/$hostConfig/$locale/messages": typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesIndexLazyRoute;
  "/$tenantId/$messengerId/$hostConfig/$locale/news": typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutNewsIndexLazyRoute;
  "/$tenantId/$messengerId/$hostConfig/$locale/messages/new": typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesNewIndexRoute;
  "/$tenantId/$messengerId/$hostConfig/$locale/messages/$id": typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesIdIndexLazyRoute;
  "/$tenantId/$messengerId/$hostConfig/$locale/help/$type/$id": typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHelpTypeIdIndexLazyRoute;
}

export interface FileRoutesById {
  __root__: typeof rootRoute;
  "/$tenantId/$messengerId/$hostConfig": typeof TenantIdMessengerIdHostConfigRouteWithChildren;
  "/$tenantId/$messengerId/$hostConfig/_launcherLayout": typeof TenantIdMessengerIdHostConfigLauncherLayoutRouteWithChildren;
  "/$tenantId/$messengerId/$hostConfig/_launcherLayout/": typeof TenantIdMessengerIdHostConfigLauncherLayoutIndexLazyRoute;
  "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale": typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleRouteWithChildren;
  "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout": typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutRouteWithChildren;
  "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout": typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutRouteWithChildren;
  "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/launcher/": typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutLauncherIndexLazyRoute;
  "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/login/": typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutLoginIndexLazyRoute;
  "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/help/": typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHelpIndexLazyRoute;
  "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/home/": typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHomeIndexLazyRoute;
  "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/launcherAuth/": typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutLauncherAuthIndexLazyRoute;
  "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/": typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesIndexLazyRoute;
  "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/news/": typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutNewsIndexLazyRoute;
  "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/new/": typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesNewIndexRoute;
  "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/$id/": typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesIdIndexLazyRoute;
  "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/help/$type/$id/": typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHelpTypeIdIndexLazyRoute;
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/$tenantId/$messengerId/$hostConfig"
    | "/$tenantId/$messengerId/$hostConfig/"
    | "/$tenantId/$messengerId/$hostConfig/$locale"
    | "/$tenantId/$messengerId/$hostConfig/$locale/launcher"
    | "/$tenantId/$messengerId/$hostConfig/$locale/login"
    | "/$tenantId/$messengerId/$hostConfig/$locale/help"
    | "/$tenantId/$messengerId/$hostConfig/$locale/home"
    | "/$tenantId/$messengerId/$hostConfig/$locale/launcherAuth"
    | "/$tenantId/$messengerId/$hostConfig/$locale/messages"
    | "/$tenantId/$messengerId/$hostConfig/$locale/news"
    | "/$tenantId/$messengerId/$hostConfig/$locale/messages/new"
    | "/$tenantId/$messengerId/$hostConfig/$locale/messages/$id"
    | "/$tenantId/$messengerId/$hostConfig/$locale/help/$type/$id";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/$tenantId/$messengerId/$hostConfig"
    | "/$tenantId/$messengerId/$hostConfig/$locale"
    | "/$tenantId/$messengerId/$hostConfig/$locale/launcher"
    | "/$tenantId/$messengerId/$hostConfig/$locale/login"
    | "/$tenantId/$messengerId/$hostConfig/$locale/help"
    | "/$tenantId/$messengerId/$hostConfig/$locale/home"
    | "/$tenantId/$messengerId/$hostConfig/$locale/launcherAuth"
    | "/$tenantId/$messengerId/$hostConfig/$locale/messages"
    | "/$tenantId/$messengerId/$hostConfig/$locale/news"
    | "/$tenantId/$messengerId/$hostConfig/$locale/messages/new"
    | "/$tenantId/$messengerId/$hostConfig/$locale/messages/$id"
    | "/$tenantId/$messengerId/$hostConfig/$locale/help/$type/$id";
  id:
    | "__root__"
    | "/$tenantId/$messengerId/$hostConfig"
    | "/$tenantId/$messengerId/$hostConfig/_launcherLayout"
    | "/$tenantId/$messengerId/$hostConfig/_launcherLayout/"
    | "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale"
    | "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout"
    | "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout"
    | "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/launcher/"
    | "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/login/"
    | "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/help/"
    | "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/home/"
    | "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/launcherAuth/"
    | "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/"
    | "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/news/"
    | "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/new/"
    | "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/$id/"
    | "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/help/$type/$id/";
  fileRoutesById: FileRoutesById;
}

export interface RootRouteChildren {
  TenantIdMessengerIdHostConfigRoute: typeof TenantIdMessengerIdHostConfigRouteWithChildren;
}

const rootRouteChildren: RootRouteChildren = {
  TenantIdMessengerIdHostConfigRoute: TenantIdMessengerIdHostConfigRouteWithChildren,
};

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/$tenantId/$messengerId/$hostConfig"
      ]
    },
    "/$tenantId/$messengerId/$hostConfig": {
      "filePath": "$tenantId/$messengerId/$hostConfig",
      "children": [
        "/$tenantId/$messengerId/$hostConfig/_launcherLayout"
      ]
    },
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout": {
      "filePath": "$tenantId/$messengerId/$hostConfig/_launcherLayout.tsx",
      "parent": "/$tenantId/$messengerId/$hostConfig",
      "children": [
        "/$tenantId/$messengerId/$hostConfig/_launcherLayout/",
        "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale"
      ]
    },
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/": {
      "filePath": "$tenantId/$messengerId/$hostConfig/_launcherLayout/index.lazy.tsx",
      "parent": "/$tenantId/$messengerId/$hostConfig/_launcherLayout"
    },
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale": {
      "filePath": "$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale",
      "parent": "/$tenantId/$messengerId/$hostConfig/_launcherLayout",
      "children": [
        "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout"
      ]
    },
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout": {
      "filePath": "$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout.tsx",
      "parent": "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale",
      "children": [
        "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout",
        "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/launcher/",
        "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/login/"
      ]
    },
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout": {
      "filePath": "$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout.tsx",
      "parent": "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout",
      "children": [
        "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/help/",
        "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/home/",
        "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/launcherAuth/",
        "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/",
        "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/news/",
        "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/new/",
        "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/$id/",
        "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/help/$type/$id/"
      ]
    },
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/launcher/": {
      "filePath": "$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/launcher/index.lazy.tsx",
      "parent": "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout"
    },
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/login/": {
      "filePath": "$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/login/index.lazy.tsx",
      "parent": "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout"
    },
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/help/": {
      "filePath": "$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/help/index.lazy.tsx",
      "parent": "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout"
    },
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/home/": {
      "filePath": "$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/home/index.lazy.tsx",
      "parent": "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout"
    },
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/launcherAuth/": {
      "filePath": "$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/launcherAuth/index.lazy.tsx",
      "parent": "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout"
    },
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/": {
      "filePath": "$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/index.lazy.tsx",
      "parent": "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout"
    },
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/news/": {
      "filePath": "$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/news/index.lazy.tsx",
      "parent": "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout"
    },
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/new/": {
      "filePath": "$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/new/index.tsx",
      "parent": "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout"
    },
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/$id/": {
      "filePath": "$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/$id/index.lazy.tsx",
      "parent": "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout"
    },
    "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/help/$type/$id/": {
      "filePath": "$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/help/$type/$id/index.lazy.tsx",
      "parent": "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout"
    }
  }
}
ROUTE_MANIFEST_END */
